export default __webpack_public_path__ + "static/media/Neurology.a18a8135.png";